import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    data: [],
    available: []
};
function pairResource(data) {
    var broker = {
        id: data.broker.id,
        name: data.broker.name,
        separator: data.broker.separator,
        hasUniqueTradeId: data.broker.hasUniqueTradeId
    };
    return {
        id: data.id,
        name: data.name,
        baseCurrency: data.baseCurrency,
        quoteCurrency: data.quoteCurrency,
        maxSum: data.maxSum,
        broker: broker,
        restartMaxTimeValue: data.restartMaxTimeValue,
        minQuantity: data.minQuantity
    };
}
export var PairReducer = createSlice({
    name: 'pairs',
    initialState: initialState,
    reducers: {
        set: function set(state, payloadAction) {
            var data = [];
            payloadAction.payload.forEach(function (item) {
                data[item.id] = pairResource(item);
            });
            state.data = data;
        },
        setAvailable: function setAvailable(state, payloadAction) {
            state.available = payloadAction.payload;
        },
        add: function add(state, payloadAction) {
            var pair = pairResource(payloadAction.payload);
            state.data[pair.id] = pair;
        },
        del: function del(state, payloadAction) {
            state.data.splice(payloadAction.payload, 1);
        },
        update: function update(state, payloadAction) {
            var pair = pairResource(payloadAction.payload);
            state.data[pair.id] = pair;
        }
    }
});
var _PairReducer$actions = PairReducer.actions, add = _PairReducer$actions.add, set = _PairReducer$actions.set, del = _PairReducer$actions.del, update = _PairReducer$actions.update, setAvailable = _PairReducer$actions.setAvailable;
export { add, set, del, update, setAvailable };
export default PairReducer.reducer;
